<section class="bg-home d-flex align-items-center position-relative"
  style="background: url('assets/images/shape01.png') center;">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="form-signin p-4 bg-white rounded shadow">
          <form [formGroup]="loginMemberFg" (ngSubmit)="onSubmitMember()">
            <a (click)="routeHelper.navigated('/')">
              <img src="assets/logo/prima-new-logo.png" class="mb-4 d-block mx-auto" alt=""
                style="width: 50%;">
            </a>
            <h5 class="mb-3 text-center">Sign in to your account</h5>

            <div class="form-floating mb-2">
              <input type="email" class="form-control"
                [ngClass]="{ 'input-danger': validate.email.invalid && validate.email.touched}" id="floatingInput"
                formControlName="email" placeholder="name@example.com">
              <label for="floatingInput">Email address</label>
              <small class="text-danger" *ngIf="validate.email.invalid && validate.email.touched">
                is required
              </small>
            </div>
            <div class="form-floating mb-3">
              <input type="password" class="form-control"
                [ngClass]="{ 'input-danger': validate.password.invalid && validate.password.touched}" id="floatingPassword"
                formControlName="password" placeholder="Password">
              <label for="floatingPassword">Password</label>
              <small class="text-danger" *ngIf="validate.password.invalid && validate.password.touched">
                is required
              </small>
            </div>

            <div class="d-flex justify-content-between">
              <div class="mb-3">
                &nbsp;
              </div>
              <p class="forgot-pass mb-0">
                <a href="javascript:void(0)" (click)="routeHelper.navigated('forgot-password')"
                  class="color-brand small fw-bold">
                  Forgot password ?</a>
              </p>
            </div>
            <div class="form-floating mb-3">
               <ngx-recaptcha2 #captchaElem
                  [siteKey]="siteKey"
                  [useGlobalDomain]="true"
                  [size]="size"
                  [theme]="themecaptcha"
                  [type]="type"
                  formControlName="recaptcha">
                </ngx-recaptcha2>

            </div>
            <div class="d-flex justify-content-between">
              <button type="submit" class="btn btn-brand w-100" [disabled]="preloader">
                <span *ngIf="preloader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                Sign in
              </button>
            </div>
            <div class="col-12 text-center mt-3">
              <p class="mb-0 mt-3">
                <small class="text-dark me-2">Don't have an account ?</small>
                <a href="javascript:void(0)" (click)="routeHelper.navigated('register')"
                  class="color-brand fw-bold ">Sign Up</a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
